import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Skeleton styles matching GameMatchRow layout (row with left column + odds block)
 */
export const getCreateGamesStepSkeletonStyles = (theme: Theme) =>
  StyleSheet.create({
    matchRowSkeleton: {
      flexDirection: 'row',
      backgroundColor: theme.background.card,
      borderRadius: 12,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: theme.gray[200],
      overflow: 'hidden',
      minHeight: 56,
    },
    matchRowSkeletonLeft: {
      flex: 1,
      justifyContent: 'center',
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRightWidth: 1,
      borderRightColor: theme.gray[200],
      gap: 6,
    },
    matchRowSkeletonOdds: {
      flex: 1,
      flexDirection: 'row',
      minWidth: 0,
      backgroundColor: theme.gray[100],
    },
    matchRowSkeletonOddsBox: {
      flex: 1,
      height: 56,
      borderRightWidth: 1,
      borderRightColor: theme.gray[200],
    },
    matchRowSkeletonOddsBoxLast: {
      borderRightWidth: 0,
    },
  });
